// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxIcon_checkbox__ZsUp5"};